import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
export default function Copyright({ copyright, apStatement }) {
    const updatedCopyright = copyright === null || copyright === void 0 ? void 0 : copyright.replace(/-\d+/, `-${new Date().getFullYear()}`);
    return (React.createElement(React.Fragment, null,
        React.createElement(RawHTML, { html: updatedCopyright }),
        React.createElement(RawHTML, { Tag: "ap-html", html: apStatement })));
}
